import React, { useState } from 'react';
import '../styles/Navbar.css'
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { SiGooglescholar } from "react-icons/si";
import { FaOrcid } from "react-icons/fa";
import { MdDarkMode } from "react-icons/md";
import { HiMenu, HiX } from "react-icons/hi";

export default function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const onActive = (id) => {
        document.getElementById(id).style.color='rgb(0, 5, 156)'
        // Close mobile menu when a link is clicked
        setIsMenuOpen(false);
    }

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    }

    return (
        <div className='navbar-container'>
            <div className='navbar'>
                <div className='nav-left'>
                    {/* Desktop: Show scholar icon and social icons */}
                    <div className='desktop-nav-left'>
                        <div className='icon active'>
                           <a href="https://orcid.org/0009-0008-9241-3967" target="_blank" rel="noopener noreferrer"><FaOrcid color='#fff' size={30}/> </a>
                        </div>
                        <div className='icon'>
                            <a href="https://github.com/a4r1" target="_blank" rel="noopener noreferrer">
                            <FaGithub color='#fff' size={30}/> </a>
                        </div>
                        <div className='icon'>
                           <a href="https://www.linkedin.com/in/arulsham-b-68376b288" target="_blank" rel="noopener noreferrer"><FaLinkedin color='#fff' size={30}/> </a>
                        </div>
                    </div>
                    
                    {/* Mobile: Show name/brand */}
                    <div className='mobile-brand'>
                        <h2>Arulsham Bhasin</h2>
                    </div>
                </div>

                {/* Hamburger Menu Button */}
                <div className='hamburger' onClick={toggleMenu}>
                    {isMenuOpen ? (
                        <HiX color='#fff' size={30} />
                    ) : (
                        <HiMenu color='#fff' size={30} />
                    )}
                </div>

                <div className={`nav-right ${isMenuOpen ? 'nav-open' : ''}`}>
                    <a onClick={() => onActive('1')} id='1' href="/">About</a>
                    {/* <a onClick={() => onActive('6')} id='1' href="/projects/project-one.md">Manifesto</a> */}
                    {/* html files works */}
                    {/* <a onClick={() => onActive('4')} id='4' href="/blog">Blog</a> */}
                    {/* <a onClick={() => onActive('2')} id='2' href="/research">Research</a> */}
                    <a onClick={() => onActive('3')} id='3' href="/project">Projects</a>
                    {/* <a onClick={() => onActive('7')} id='7' href="/music">Music</a> */}
                    <a onClick={() => onActive('5')} id='5' href="/Contact">Contact</a>
                    
                    {/* <div className='icon desktop-darkmode'>
                        <MdDarkMode color='#fff' size={30} />
                    </div> */}
                    
                    {/* Mobile: Social Icons and Dark Mode at bottom of menu */}
                    <div className='mobile-menu-bottom'>
                        <div className='mobile-social'>
                            <div className='icon'>
                              <a href="https://orcid.org/0009-0008-9241-3967" target="_blank" rel="noopener noreferrer"><FaOrcid color='#fff' size={30}/> </a>

                            </div>
                            <div className='icon'>
                                 <a href="https://github.com/a4r1" target="_blank" rel="noopener noreferrer">
                            <FaGithub color='#fff' size={30}/> </a>
                            </div>
                            <div className='icon'>
                                 <a href="https://www.linkedin.com/in/arulsham-b-68376b288" target="_blank" rel="noopener noreferrer"><FaLinkedin color='#fff' size={30}/> </a>
                            </div>
                        </div>
                        {/* <div className='icon mobile-darkmode'>
                            <MdDarkMode color='#fff' size={30} />
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}